import React, { useState, useRef, useEffect } from 'react';
import handleupload from '../../utilities/handleUpload';
import { Edit } from '@mui/icons-material';
import PDFViewer from '../../utilities/PDFViewer';
import { Media } from 'reactstrap';
import { toast } from 'react-toastify';
// import { UPLOAD_PATH_SECRET_KEY } from "../../constant";

const FileUploadComponent = ({
  name,
  setValue,
  trigger,
  data,
  register,
  imageOnly = false,
  viewOnly = false,
  add = false,
  required = true,
  pdfOnly = false,
  csvOnly = false,
  pdfImageOnly = false,
  setCsvFile,
  setLoading,
  maxSizeMB = 1 // Default maximum file size in MB
}) => {
  const fileInputRef = useRef(null);
  const [uploadedFile, setUploadedFile] = useState(data ? data : "");
  const [isEdit, setIsEdit] = useState(true);

  const handleFileChange = async (event) => {
    try {
      const file = event.target.files[0];
      // Check for allowed file types
      if (!file) return;

      // Determine allowed file types based on component props
      let allowedFileTypes = [];
      if (csvOnly) {
        allowedFileTypes = [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'text/csv'
        ];
      } else if (pdfOnly) {
        allowedFileTypes = [
          'application/pdf'
        ];
      } else if (imageOnly) {
        allowedFileTypes = [
          'image/png',
          'image/jpeg'
        ];
      } else {
        allowedFileTypes = [
          'application/pdf',
          'image/png',
          'image/jpeg'
        ];
      }

      // Check for allowed file types
      if (!allowedFileTypes.includes(file.type)) {
        toast.error(`Invalid file type. Please upload a ${csvOnly ? 'CSV or Excel' : pdfOnly ? 'PDF' : imageOnly ? 'PNG or JPEG' : 'PDF or PNG'} file.`);
        return;
      }

      setCsvFile && setCsvFile(file);

      const maxSizeBytes = maxSizeMB * 1024 * 1024; // Convert maxSizeMB to bytes

      if (file.size > maxSizeBytes) {
        // File size exceeds maxSizeMB, handle accordingly
        toast.info(`File size exceeds ${maxSizeMB} MB. Please upload a file of size less than ${maxSizeMB} MB.`);
        return;
      }

      const dataForFile = { 'null': null, file };
      handleupload(dataForFile, 'done', name, true, setValue, trigger, setUploadedFile, setIsEdit, setLoading);
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  };

  const handleEdit = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleView = (doc_url) => {
    if (!doc_url) return;

    try {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', doc_url, true);
      xhr.responseType = 'blob';
      xhr.setRequestHeader('x-custom-header', process.env.REACT_APP_UPLOAD_PATH_SECRET_KEY);

      xhr.onload = function () {
        if (xhr.status === 200) {
          // Get the file extension
          const fileExt = doc_url.split('.').pop().toLowerCase();

          // Create a timestamp for the filename
          const timestamp = new Date().toISOString().replace(/[-:]/g, '');

          // Generate filename based on URL or use default with timestamp
          let baseName = 'file';

          // Try to extract the filename from URL
          const urlParts = doc_url.split('/');
          if (urlParts.length > 0) {
            const lastPart = urlParts[urlParts.length - 1].split('_');
            if (lastPart.length > 1) {
              baseName = lastPart[lastPart.length - 1].split('.')[0];
            }
          }

          // Final filename with timestamp
          const fileName = `${baseName}_${timestamp}.${fileExt}`;

          // Create a download link
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(xhr.response);
          link.download = fileName;

          // Trigger the download
          document.body.appendChild(link);
          link.click();

          // Clean up
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);
        } else {
          toast.error('Failed to download file. Status: ' + xhr.status);
        }
      };

      xhr.onerror = function () {
        // Fallback to opening in a new tab if download fails
        if (doc_url) {
          toast.info('Trying alternative download method...');
          window.open(doc_url, '_blank');
        } else {
          toast.error('Error downloading file');
        }
      };

      xhr.send();
    } catch (error) {
      console.error('Error in download process:', error);
      toast.error('Error processing download');
    }
  };

  const getFileType = (fileName) => {
    if (fileName?.endsWith('.pdf')) {
      return 'pdf';
    } else if (fileName?.endsWith('.csv')) {
      return 'csv';
    } else if (fileName) {
      return 'image';
    } else {
      return 'default';
    }
  };

  useEffect(() => {
    setUploadedFile(data);
    setValue && setValue(name, data);
  }, [data]);

  return (
    <div>
      {!viewOnly && (
        <input
          type="file"
          onChange={handleFileChange}
          name={name}
          accept={imageOnly ? ".jpg, .jpeg, .png, .JPG, .JPEG, .PNG" : pdfOnly ? ".pdf" : csvOnly ? ".csv" : pdfImageOnly ? ".pdf, .jpg, .jpeg, .png, .JPG, .JPEG, .PNG" : undefined}
          style={{ display: 'none' }}
          ref={fileInputRef}
          {...register(name, { required: required })}
        />
      )}

      <div className="blog-box blog-grid text-center product-box">
        <div className="product-img">
          <Media
            style={{ width: '180px', margin: 'auto' }}
            className="img-fluid top-radius-blog data-table-row-image-auto"
            src={
              getFileType(uploadedFile) == 'pdf'
                ? require('../../assets/images/pdf-thumbnail.png') : getFileType(uploadedFile) == 'csv'
                  ? require('../../assets/images/csv.png')
                  : uploadedFile ? uploadedFile : data ? data.endsWith("pdf") ? require('../../assets/images/pdf-thumbnail.png') : data.endsWith("csv") ? require('../../assets/images/csv.png') : data : require('../../assets/images/file-upload.png')
            }
            alt=""
          />

          <div className="product-hover">
            <ul>
              {!add && <li onClick={() => handleView(uploadedFile)}>
                <i title='View file' className="icon-link"></i>
              </li>}

              {!viewOnly && <li onClick={handleEdit}>
                <i title={add ? 'Add file' : 'Edit file'} className={add ? "fa fa-plus" : "fa fa-pencil"}></i>
              </li>}
            </ul>
          </div>
          {!viewOnly && (
            <small style={{ color: "#2b262691" }}>{imageOnly ? "(.jpg, .png allowed only)" : pdfOnly ? "(.pdf allowed only)" : csvOnly ? "(.csv allowed only)" : "(.pdf, .jpg, .png allowed only)"}</small>
          )}
        </div>
      </div>
    </div>
  );
};

export default FileUploadComponent;